import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import axios from 'axios';
import { COMMON_API } from '../../CommonAPI';

const EditPortfolio = () => {
    const { id } = useParams();
    const [category, setCategory] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPortfolio = async () => {
            try {
                const token = sessionStorage.getItem("authToken");
                const response = await axios.get(`${COMMON_API}/api/portfolio/get-single-portfolio/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setCategory(response.data.category);
            } catch (error) {
                toast.error("Error fetching portfolio");
            }
        };

        fetchPortfolio();
    }, [id]);

    const handleUpdate = async (e) => {
        e.preventDefault();

        try {
            const token = sessionStorage.getItem("authToken");
            await axios.put(`${COMMON_API}/api/portfolio/update-portfolio/${id}`, { category }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success("Portfolio updated successfully!");
            navigate("/portfolio");
        } catch (error) {
            toast.error("Error updating portfolio");
        }
    };

    return (
        <div className="ml-64 p-8 bg-gray-100 min-h-screen">
            <h2 className="text-3xl font-semibold mb-6 text-gray-800">Edit Portfolio</h2>
            <form onSubmit={handleUpdate} className="bg-white p-6 rounded shadow max-w-lg">
                <div className="mb-4">
                    <label className="block text-gray-700 font-medium mb-2">Category</label>
                    <input
                        type="text"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        className="w-full border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>
                <button
                    type="submit"
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
                >
                    Update Portfolio
                </button>
            </form>
        </div>
    );
};

export default EditPortfolio;
